export const invites = (state = {}, action) => {
  switch (action.type) {
    case 'LOAD_INVITE':
      return {
        ...state,
        ...action.data,
      };
    default:
      return state;
  }
};

export default invites;
